/**
 * Versão do bundle servido. Vem do build da imagem; em desenvolvimento não existe e o
 * portal diz "dev" em vez de fingir um número de versão.
 */
export const VERSAO_DO_FRONT = import.meta.env.VITE_VERSAO_GIT?.trim() || "dev";
